import React from 'react';
const moveIcon = 'fas fa-bars float-md-right move';
const MoveIcon = () => /*#__PURE__*/React.createElement("i", {
  className: "".concat(moveIcon, " t-tn-move")
});
export default MoveIcon;